












import { Component, Vue } from "vue-property-decorator";

@Component
export default class NoStoredBrandGatewaysMsg extends Vue {
  // Computed
  public get message() {
    return {
      path: this.$store.getters["isAdminContext"]
        ? "_sentence.clients_cannot_store_payment_methods"
        : "_sentence.we_do_not_support_stored_payment_methods",
      type: this.$store.getters["isAdminContext"] ? "is-warning" : "is-caution"
    };
  }
}
